import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ComingSoonStatus } from '../../../shared/components/coming-soon-status/coming-soon-status';

@Component({
    standalone: true,
    imports: [
        ComingSoonStatus,
    ],
    templateUrl: './integrations.html',
    styleUrl: './integrations.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Integrations {
    private readonly router = inject(Router);

    protected get pageTitle(): string {
        const url = this.router.url;

        if (url.includes('hardware-integration')) {
            return 'Hardware Integration';
        }

        if (url.includes('anpr-module')) {
            return 'ANPR Module';
        }

        return 'Integrations';
    }
}
